import { useEffect, useState } from 'react';
import { shallowEqual, useSelector } from 'react-redux';

import { log } from 'src/app/utils/logging';
import type AppState from 'src/types/appState';

const DEFAULT_TIMEOUT = 2000;
const DEFAULT_CALLBACK = () => {};

export const useTrackingTimer = (
  page: string,
  callback: () => void = DEFAULT_CALLBACK,
) => {
  const currentPage = useSelector(
    (state: AppState) => state.tealium.page,
    shallowEqual,
  );
  const [eventSent, setEventSent] = useState(false);

  useEffect(() => {
    let timer: NodeJS.Timeout;
    if (!eventSent && page === currentPage) {
      log.info(
        `PageViewTracker | useTrackingTimer | Starting a tracking timer for ${currentPage} page`,
      );
      timer = setTimeout(() => {
        log.warn(
          `PageViewTracker | useTrackingTimer | Event timeout. Page data for ${currentPage} is not ready. Sending incomplete data.`,
        );
        callback();
        setEventSent(true);
      }, DEFAULT_TIMEOUT);
    }
    return () => clearTimeout(timer);
  }, [eventSent, callback, currentPage, page]);

  return { eventSent, setEventSent };
};
